import { bindActions, mockTheme } from "../utils/utils";
import * as React from "react";
import { ComponentClass } from "react";
import Grid from "@material-ui/core/Grid";
import { SortDirection } from "@material-ui/core/TableCell";
import AsyncTable, { ColumnDefinition } from "../components/AsyncTable";
import { IStore } from "../store";
import withStyles from "@material-ui/core/styles/withStyles";
import { Theme, WithStyles } from "@material-ui/core";
import { connect } from "react-redux";
import { JSONSchema6 } from "json-schema";
import EnhancedSchemaForm from "../components/schemaForm";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";

import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/ModeEdit";
import PhotoIcon from "@material-ui/icons/Photo";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import VisibilityOnIcon from "@material-ui/icons/Visibility";
import SearchIcon from "@material-ui/icons/Search";

import Dialog from "@material-ui/core/Dialog";
import Button from "@material-ui/core/Button";
import { ISubmitEvent, UiSchema } from "react-jsonschema-form";
import Paper from "@material-ui/core/Paper";
import { Category, Product } from "../api/model";
import orange from "@material-ui/core/colors/orange";
import blue from "@material-ui/core/colors/blue";
import red from "@material-ui/core/colors/red";
import { ProductActions, IProductStore } from "../store/product";
import { UploadImage } from "../components/UploadImage";
import { getApi } from "../api/ApiProvider";
import green from "@material-ui/core/colors/green";
import SearchBox from "../components/SearchBox";

const styles = (theme: Theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: `calc(50% - ${theme.spacing.unit * 3}px)`,
  },
  menu: {
    width: 200,
  },

  routeSelector: {
    width: "100%",
    height: "100%",
  },
  buttons: {
    marginLeft: "auto",
  },
  abm: {
    padding: theme.spacing.unit * 3,
    margin: theme.spacing.unit,
  },
  disableIcon: {
    color: red[900],
  },
  enableIcon: {
    color: green[900],
  },
  editIcon: {
    color: blue[500],
  },
  imageIcon: {
    color: orange[500],
  },
  imageColumn: {
    width: "50px",
    padding: "5px",
    textAlign: "center",
  },
  actionHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
  },
  searchField: {
    marginTop: 2,
    fontSize: "10px",
  },
});

/**
 * This is a hack to has a object with the keys the same as the return of the #createStyles
 */
const classesType = styles(mockTheme);

interface ProductProps extends WithStyles<keyof typeof classesType> {
  actions: ProductActions;
  data: IProductStore;
  companyId: number;
}

interface ProductState {
  abm: {
    open: boolean;
    data: {
      product: Partial<Product>;
      category?: Partial<number>;
    };
  };
  photoEdit: {
    open: boolean;
    data: {
      product: Partial<Product>;
    };
  };
  table: {
    data: any;
    sortBy: string;
    sortDirection: SortDirection;
    columnData: ColumnDefinition[];
  };
  schema: any;
  image: any;
  searchText: string;
  filter: string;
}

const schema: JSONSchema6 = {
  title: "Producto",
  type: "object",
  required: ["name", "price"],
  properties: {
    name: {
      type: "string",
      title: "Nombre",
    },
    price: {
      type: "number",
      title: "Precio",
    },
    category: {
      title: "Categoria",
      type: "number",
      anyOf: [{ type: "number", enum: [0], title: "Cargando..." }],
      default: 0,
    },
  },
};

const uiSchema: UiSchema = {
  "ui:layout": [
    {
      name: { xs: 12 },
      price: { xs: 12 },
      category: { xs: 12 },
    },
  ],
};

class ProductView extends React.Component<ProductProps, ProductState> {
  static getDefaultEntity() {
    return { product: {} };
  }

  constructor(props: ProductProps) {
    super(props);
    this.state = {
      abm: {
        open: false,
        data: ProductView.getDefaultEntity(),
      },
      photoEdit: {
        open: false,
        data: ProductView.getDefaultEntity(),
      },
      table: {
        data: [],
        sortBy: "name",
        sortDirection: "desc",
        columnData: [
          {
            path: "foto",
            label: "Foto",
            draw: (cd: ColumnDefinition, data: Product) => {
              const imageTitle = this.getDataImage(data);
              return (
                <div>
                  <Tooltip title={imageTitle}>
                    <img
                      src={data.photo}
                      className={this.props.classes.imageColumn}
                    />
                  </Tooltip>
                </div>
              );
            },
          },
          {
            path: "name",
            numeric: false,
            label: "Nombre",
            disablePadding: false,
          },
          { path: "category.name", numeric: false, label: "Categoria" },
          {
            path: "price",
            numeric: true,
            label: "Precio",
            disablePadding: false,
          },
          { path: "state", numeric: false, label: "Estado" },
          {
            path: "",
            numeric: true,
            label: "Acciones",
            draw: (cd: ColumnDefinition, data: Product) => {
              return (
                <div style={{ minWidth: 150 }}>
                  <IconButton
                    className={this.props.classes.imageIcon}
                    aria-label="Agregar Imagen"
                    onClick={this.addImage(data)}
                  >
                    <Tooltip title="Agregar imagen">
                      <PhotoIcon />
                    </Tooltip>
                  </IconButton>
                  <IconButton
                    className={this.props.classes.editIcon}
                    aria-label="Editar"
                    onClick={this.edit(data)}
                  >
                    <Tooltip title="Editar">
                      <EditIcon />
                    </Tooltip>
                  </IconButton>
                  <IconButton
                    className={
                      data.state === "ACTIVE"
                        ? this.props.classes.enableIcon
                        : this.props.classes.disableIcon
                    }
                    onClick={this.handleDisable(data)}
                  >
                    {data.state === "ACTIVE" ? (
                      <Tooltip title="Activo">
                        <VisibilityOnIcon />
                      </Tooltip>
                    ) : (
                      <Tooltip title="Inactivo">
                        <VisibilityOffIcon />
                      </Tooltip>
                    )}
                  </IconButton>
                </div>
              );
            },
          },
        ],
      },
      image: null,
      schema: schema,
      searchText: "",
      filter: "",
    };

    this.fillCategoryInSchema(0);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.showDialog = this.showDialog.bind(this);
    this.hideDialog = this.hideDialog.bind(this);
    this.handleDisable = this.handleDisable.bind(this);
    this.showPhotoEdit = this.showPhotoEdit.bind(this);
    this.handleImageChange = this.handleImageChange.bind(this);
    this.uploadImage = this.uploadImage.bind(this);
    this.filter = this.filter.bind(this);
    this.edit = this.edit.bind(this);
  }

  fillCategoryInSchema(id: number) {
    getApi()
      .category()
      .listAvailable(this.props.companyId)
      .then((data: Category[]) => {
        const newSchema: JSONSchema6 = JSON.parse(JSON.stringify(schema));
        const category = newSchema.properties!.category as JSONSchema6;

        const filterActive = data.filter((d) => d.state === "ACTIVE");

        category.default = id;
        category.anyOf = filterActive.map((d) => {
          return {
            type: "number",
            enum: [d.id],
            title: d.name || "",
          } as JSONSchema6;
        });

        this.setState({ schema: newSchema });
      });
  }

  getDataImage(data: Product) {
    const img = new Image();
    img.src = data.photo;
    const extensionIndex = img.src.lastIndexOf(".");
    const extension =
      extensionIndex !== -1 ? img.src.substring(extensionIndex + 1) : "ninguno";

    img.onload = () => {
      console.log("onload image");
    };
    const dato =
      "Tamaño:" +
      img.width +
      " x " +
      img.height +
      "\n" +
      "Tipo: " +
      // "com/350/250 corresponde al placeHolder"
      (extension !== "com/350/250" ? extension.toUpperCase() : "WEB");

    return dato;
  }

  handleDisable(data: any) {
    return (event: React.MouseEvent<HTMLElement>) => {
      console.log(data);
      this.props.actions.disable(this.props.companyId, data.id);
    };
  }

  addImage(data: Product) {
    return (event: any) => {
      this.setState({
        photoEdit: {
          open: true,
          data: {
            product: data,
          },
        },
      });
    };
  }

  edit(data: Product) {
    return (event: React.MouseEvent<HTMLElement>) => {
      this.fillCategoryInSchema(data.category!.id);

      const { id, price, photo, state, name } = data;
      this.setState({
        abm: {
          open: true,
          data: {
            product: {
              id: id,
              name: name,
              price: price,
              photo: photo,
              state: state,
            },
            category: data.category!.id,
          },
        },
        schema: schema,
      });
    };
  }

  handleSubmit(e: ISubmitEvent<any>) {
    const { id, price, photo, category, state, name } = e.formData;

    e.formData.product = {
      id: id,
      name: name,
      photo: photo ? photo : "https://via.placeholder.com/250/250",
      category: category,
      price: price,
      state: state,
    };

    this.props.actions.save(this.props.companyId, {
      ...e.formData,
    });
    this.hideDialog();
  }

  sort(name: string) {
    return () => {
      this.setState({
        ...this.state,
        table: {
          ...this.state.table,
          sortBy: name,
          sortDirection: "desc",
        },
      });
    };
  }

  componentDidMount() {
    this.props.actions.fetch(this.props.companyId);
  }

  hideDialog() {
    this.setState({
      abm: { ...this.state.abm, open: false },
      photoEdit: { ...this.state.photoEdit, open: false },
    });
  }

  showDialog() {
    this.setState({
      abm: { data: ProductView.getDefaultEntity(), open: true },
    });
    this.fillCategoryInSchema(0);
  }

  showPhotoEdit() {
    this.setState({
      photoEdit: { data: ProductView.getDefaultEntity(), open: true },
      image: null,
    });
  }

  handleImageChange(event: any) {
    console.log("AQUI", event.target.files!.item(0));
    this.setState({
      image: event.target.files!.item(0),
      photoEdit: {
        ...this.state.photoEdit,
        data: {
          product: {
            ...this.state.photoEdit.data.product,
            photo: URL.createObjectURL(event.target.files!.item(0)),
          },
        },
      },
    });
  }

  uploadImage() {
    const image: File = this.state.image;
    const productId = this.state.photoEdit.data.product.id!;
    const companyId = this.props.companyId;
    this.props.actions.uploadImage(companyId, productId, image);
  }

  filter(search: any, filter: any) {
    console.log(search, filter);
    const s = search == null ? this.state.searchText : search;
    const f = filter == null ? this.state.filter : filter;

    this.props.actions.filter(this.props.companyId, s, f);
  }

  render() {
    return (
      <Grid container spacing={24}>
        <Grid item sm={12} md={12}>
          <div className={this.props.classes.actionHeader}>
            <SearchBox
              placeHolder="Ingrese producto y presione ENTER"
              doSearch={(search) => {
                this.setState({ searchText: search });
                this.filter(search, null);
              }}
              doFilter={(filter) => {
                this.setState({ filter: filter });
                this.filter(null, filter);
              }}
              hasFilter={true}
            />
          </div>
        </Grid>
        <Grid item sm={12} md={12}>
          <AsyncTable
            columnDefinition={this.state.table.columnData}
            title="Productos"
            data={this.props.data.data}
            defaultOrder={{
              name: "name",
              direction: "desc",
            }}
            headerButtons={
              <div className={this.props.classes.actionHeader}>
                <Tooltip title="Agregar Producto">
                  <IconButton
                    aria-label="Agregar Producto"
                    onClick={this.showDialog}
                  >
                    <AddIcon />
                  </IconButton>
                </Tooltip>
              </div>
            }
          />
        </Grid>
        <Dialog open={this.state.abm.open} maxWidth="md" fullWidth={false}>
          <Paper className={this.props.classes.abm}>
            <EnhancedSchemaForm
              schema={this.state.schema}
              formData={this.state.abm.data.product}
              uiSchema={uiSchema}
              onSubmit={this.handleSubmit}
            >
              <div>
                <Button variant="contained" onClick={this.hideDialog}>
                  Cancelar
                </Button>
                &nbsp;
                <Button variant="contained" color="primary" type="submit">
                  Aceptar
                </Button>
              </div>
            </EnhancedSchemaForm>
          </Paper>
        </Dialog>
        {
          <Dialog
            open={this.state.photoEdit.open}
            maxWidth="sm"
            fullWidth={false}
          >
            {/* <Paper> */}
            <UploadImage
              value={this.state.photoEdit.data.product.photo}
              label="Subir Imagen Producto"
              onImageChange={this.handleImageChange}
              onCancel={this.hideDialog}
              doUpload={this.uploadImage}
            />
            {/* </Paper> */}
          </Dialog>
        }
      </Grid>
    );
  }
}

const mapStateToProps = (state: IStore, ownProps: ProductProps) => ({
  ...ownProps,
  data: state.product,
  companyId: state.auth.user!.companyId,
});

const styled = withStyles(styles as any)(ProductView);
const connected = connect(mapStateToProps, bindActions(ProductActions))(styled);

export default connected as ComponentClass<Partial<ProductProps>>;



// WEBPACK FOOTER //
// ./src/pages/ProductListPage.tsx